import {Box, Button} from '@mui/material';
import {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './selectLang.scss';
import {useTranslation} from "react-i18next";

const LangSelecter = ({setIsLangSelecter}: any) => {
    const { t, i18n } = useTranslation();
    const [activeLang, setActiveLang] = useState<any>(localStorage.getItem('lang') ?? 'ru')
    const lang = [
        {
            title: 'Русский',
            id: 'ru'
        },
        {
            title: 'Қазақ',
            id: 'kz'
        },
        {
            title: 'English',
            id: 'en'
        },
    ]


    const changeFun = (id: string) => {
        localStorage.setItem('lang', id);
        setActiveLang(id);
        i18n.changeLanguage(id);
        setIsLangSelecter(false);
    };


    return <Box className={'selectLangWrp'}>
        <Box className={'selectLangExit'} onClick={() => {
            setIsLangSelecter(false)
        }}><CloseIcon/></Box>
        <Box className={'langTitle'}>{t('Язык')}</Box>
        <Box className={'langList'}>
            {lang.map(el => {
                return <Button onClick={() => changeFun(el.id)}
                               className={el.id === activeLang ? 'active' : 'langBtn'}>{el.title}</Button>
            })}
        </Box>
    </Box>
}

export default LangSelecter